const tech_img = require("../../assets/img/tutorials/urbanismo/tech.png");
const secondary_tech_img = require("../../assets/img/tutorials/urbanismo/secondary-tech.png");
const func_img = require("../../assets/img/tutorials/urbanismo/func.png");
const secondary_func_img = require("../../assets/img/tutorials/urbanismo/secondary-func.png");

export const UrbanismoSteps = [
  {
    name: "Gemelo Digital de Urbanismo en Madrid",
    title: "Descripción funcional",
    description: (
      <span>
        <p>
          El gemelo digital de <b>Urbanismo</b> ofrece una visión completa y
          detallada de la estructura urbana de la ciudad. Permite categorizar y
          visualizar diferentes edificios y estructuras relevantes, así como
          información sobre su posición, descripción, año de construcción y
          enlaces a la ficha urbanística correspondiente.
        </p>
        <p>
          A través de la integración de fuentes de datos urbanísticas, el gemelo
          digital proporciona una representación detallada de la ciudad de
          Madrid en cartografía 2D y 3D. Esto permite una interpretación precisa
          de la distribución y disposición de los edificios y estructuras dentro
          del entorno urbano.
        </p>
      </span>
    ),
    secondarydescription: (
      <span>
        <p>Área de Gobierno de Urbanismo, Medio Ambiente y Movilidad</p>
      </span>
    ),
    mainimage: <img src={func_img} alt="main_func" />,
    secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
  },
  {
    name: "Gemelo Digital de Urbanismo en Madrid",
    title: "Descripción técnica",
    description: (
      <div>
        <span>
          Integraciones técnicas
          <ul>
            <li>
              <b>Integración de Cartografía 2D y 3D</b>: Permite una
              representación detallada y realista del entorno urbano de Madrid,
              incluyendo la disposición y distribución de edificios y
              estructuras.
            </li>
            <li>
              <b>Integración de fuentes de datos urbanísticas</b>: Proporciona
              información precisa sobre la posición, descripción, año de
              construcción y enlaces a la ficha urbanística de cada edificio y
              estructura relevante en Madrid.
            </li>
          </ul>
        </span>
        <span>
          Origen de Datos
          <ul>
            <li>
              <b>Fuentes de datos urbanísticas</b>: Incluyen bases de datos
              municipales, registros de construcción, y otras fuentes que
              contienen información detallada sobre la estructura urbana de
              Madrid.
            </li>
          </ul>
        </span>
      </div>
    ),
    mainimage: <img src={tech_img} alt="main_tech" />,
    secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
  },
];
